export default __webpack_public_path__ + "static/media/blog-img110.ecfbe8d5.jpg";